import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { BLANK_SIGN_UP_SUGGESTIONS } from "@faire/retailer-visitor-shared/stores/domain/SSO/SSOContextStore";
import { useSSOErrorStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOErrorStore";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { getWebApiErrorMessage } from "@faire/web--source/common/getErrorMessage";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { FAIRE_DIRECT_BRAND_QUERY_PARAM } from "@faire/web--source/common/routes/faire-direct/FAIRE_DIRECT_BRAND_QUERY_PARAM";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import login from "@faire/web-api--source/api/v2/users/login/post";
import { trackSigninUsePasswordToLinkSso } from "@faire/web-api--source/events/signin/actionUnknown/usePasswordToLinkSso";
import { trackSigninSsoErrorError } from "@faire/web-api--source/events/signin/error/ssoError";
import { trackSigninTriggersMfaSubmit } from "@faire/web-api--source/events/signin/submit/triggersMfa";
import { trackSigninSsoSuccessSuccess } from "@faire/web-api--source/events/signin/success/ssoSuccess";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";
import { LoginState } from "@faire/web-api--source/indigofair/data/LoginState";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import signUpPersonal, { QueryParameters as SignUpQueryParameters } from "@faire/web-api--source/routes/welcome/r/personal";
import { useHistory } from "react-router-dom";
export var useHandleSSOSuccess = function(param) {
    var onSignIn = param.onSignIn, onSelectMFA = param.onSelectMFA, onMFA = param.onMFA, onConfirmPassword = param.onConfirmPassword, provider = param.provider, sourceId = param.sourceId;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var setErrorMessage = useSSOErrorStore().setErrorMessage;
    var _useSSOStore = useSSOStore(), reset = _useSSOStore.reset, set = _useSSOStore.set;
    var replace = useHistory().replace;
    var queryParams = useQueryParams(SignUpQueryParameters.parse);
    var _useFaireDirectBrand = useFaireDirectBrand(), isFaireDirectActiveInLoggedOut = _useFaireDirectBrand.isFaireDirectActiveInLoggedOut, faireDirectBrand = _useFaireDirectBrand.faireDirectBrand, faireDirectBrandToken = _useFaireDirectBrand.faireDirectBrandToken, faireDirectBrandAlias = _useFaireDirectBrand.faireDirectBrandAlias;
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(id_token, appleResponseUser) {
            var sso_token, _ref, user, mfa_description, mfa_title, mfa_options, login_state, sign_up_suggestions, signUpSuggestions, faireDirectParams, _queryParams_signUp, error, defaultErrorMessage;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sso_token = {
                            id_token: id_token,
                            provider: provider
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            login(ILoginRequest.build({
                                sso_token: sso_token,
                                enable_mfa_method_selection: true
                            }))
                        ];
                    case 2:
                        _ref = _state.sent(), user = _ref.user, mfa_description = _ref.mfa_description, mfa_title = _ref.mfa_title, mfa_options = _ref.mfa_options, login_state = _ref.login_state, sign_up_suggestions = _ref.sign_up_suggestions;
                        reset();
                        signUpSuggestions = generateSignUpSuggestions(provider, BLANK_SIGN_UP_SUGGESTIONS, sign_up_suggestions, appleResponseUser);
                        set(signUpSuggestions, id_token, provider);
                        faireDirectParams = isFaireDirectActiveInLoggedOut ? _define_property({
                            brand: faireDirectBrandToken,
                            brandName: faireDirectBrand === null || faireDirectBrand === void 0 ? void 0 : faireDirectBrand.name
                        }, FAIRE_DIRECT_BRAND_QUERY_PARAM, faireDirectBrandAlias) : {};
                        trackSigninSsoSuccessSuccess(provider, sourceId, login_state);
                        switch(login_state){
                            case LoginState.LOGIN_OK:
                                if (user) {
                                    onSignIn(user);
                                }
                                break;
                            case LoginState.SIGN_UP_REQUIRED:
                                ;
                                replace(signUpPersonal(_object_spread_props(_object_spread({}, queryParams, faireDirectParams), {
                                    signUp: isFaireDirectActiveInLoggedOut ? SignUpType.FAIRE_DIRECT : (_queryParams_signUp = queryParams.signUp) !== null && _queryParams_signUp !== void 0 ? _queryParams_signUp : SignUpType.GENERIC,
                                    email: signUpSuggestions === null || signUpSuggestions === void 0 ? void 0 : signUpSuggestions.email_address
                                })));
                                break;
                            case LoginState.MFA_METHOD_SELECTION_REQUIRED:
                                trackSigninTriggersMfaSubmit("SSO");
                                onSelectMFA(mfa_options);
                                break;
                            case LoginState.MFA_REQUIRED:
                                trackSigninTriggersMfaSubmit("SSO");
                                onMFA(mfa_description !== null && mfa_description !== void 0 ? mfa_description : strictLocalize({
                                    id: "xm0J9s",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Almost there! Please enter the code sent to your email"
                                        }
                                    ]
                                }), mfa_title !== null && mfa_title !== void 0 ? mfa_title : strictLocalize({
                                    id: "0dap3n",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Enter verification code"
                                        }
                                    ]
                                }));
                                break;
                            case LoginState.SOCIAL_LOGIN_PASSWORD_REQUIRED:
                                trackSigninUsePasswordToLinkSso();
                                onConfirmPassword(signUpSuggestions);
                                break;
                            default:
                                // login_state is ISSUED_LOGIN_CODE or LOGIN_STATE_UNKNOWN
                                setErrorMessage(strictLocalize({
                                    id: "AM1yxm",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Sorry, server was unable to process request."
                                        }
                                    ]
                                }));
                                break;
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        defaultErrorMessage = strictLocalize({
                            id: "ZYHi/m",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Sorry, was unable to reach server"
                                }
                            ]
                        });
                        setErrorMessage(getWebApiErrorMessage(error, strictLocalize, defaultErrorMessage));
                        trackSigninSsoErrorError(provider, sourceId);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id_token, appleResponseUser) {
            return _ref.apply(this, arguments);
        };
    }();
};
var generateSignUpSuggestions = function(provider, BLANK_SIGN_UP_SUGGESTIONS, sign_up_suggestions, appleResponseUser) {
    if (provider !== SocialSignOnProvider.APPLE) {
        return sign_up_suggestions;
    }
    // For Apple
    var ssoStorePayload = BLANK_SIGN_UP_SUGGESTIONS;
    var email_address;
    if (appleResponseUser) {
        var email = appleResponseUser.email, _appleResponseUser_name = appleResponseUser.name, firstName = _appleResponseUser_name.firstName, lastName = _appleResponseUser_name.lastName;
        var _sign_up_suggestions_email_address;
        email_address = (_sign_up_suggestions_email_address = sign_up_suggestions === null || sign_up_suggestions === void 0 ? void 0 : sign_up_suggestions.email_address) !== null && _sign_up_suggestions_email_address !== void 0 ? _sign_up_suggestions_email_address : email;
        ssoStorePayload = {
            email_address: email_address,
            first_name: firstName,
            last_name: lastName,
            profile_image_url: "",
            provider: provider
        };
    } else {
        var _sign_up_suggestions_email_address1;
        email_address = (_sign_up_suggestions_email_address1 = sign_up_suggestions === null || sign_up_suggestions === void 0 ? void 0 : sign_up_suggestions.email_address) !== null && _sign_up_suggestions_email_address1 !== void 0 ? _sign_up_suggestions_email_address1 : "";
        ssoStorePayload = _object_spread_props(_object_spread({}, ssoStorePayload), {
            email_address: email_address,
            provider: provider
        });
    }
    return ssoStorePayload;
};
